import { Box } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'

import SplitAuthLayout from '@components/SplitAuthLayout'
import BackToLogin from '@components/BackToLogin'

const VerificationPage = () => {
  const intl = useIntl()
  return (
    <SplitAuthLayout
      heading={intl.formatMessage({ id: 'verification.welcome' })}
      dataTestId='verification-page'
      back={<BackToLogin />}
    >
      <Box sx={{ color: tokens.businessBlack60, fontSize: 14, lineHeight: 1.4 }}>
        <FormattedMessage id='verification.body' />
      </Box>
    </SplitAuthLayout>
  )
}

export default VerificationPage
